module.exports = function (element) {
  element.id = 'showoff-css'
  document.head.prepend(element)
}
